import React from "react";
import InputLabel from "@mui/material/InputLabel";
import { FormControl } from "@mui/material";
import { isEmpty } from "../../util/is";
import { Controller } from "react-hook-form";
import Tooltip from "@mui/material/Tooltip";
import "../styles.css"

const TimeForm = ({
    identificador,
    label, 
    value = null, 
    handleChange, 
    width = `100%`, 
    widthContainer = "170px",
    disabled = false, 
    className="classDefaultTimeForm",
    inputProps={}, 
    required = false, 
    readOnly= false, 
    rules = {}, 
    customError = null, 
    nestedValue = null,
    style = {}
}) => {

    return(
        <FormControl key={`key${identificador}`}  className={`my-1 ${className}`} style={{width: widthContainer}}>
            <Tooltip title={`${required ? `*${label}` : `${label}`}`}>
                <InputLabel 
                    shrink 
                    htmlFor={identificador} 
                    style={{width, fontWeight: 'bold', textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", pointerEvents: "auto"}}
                >
                    {`${required ? `*${label}` : `${label}`}`}
                </InputLabel>
            </Tooltip>

            {!('control' in inputProps) ?
                <input 
                    type="time" 
                    className="inputTime"
                    disabled={disabled}
                    name={identificador}
                    value={value}
                    readOnly={readOnly}
                    onChange={({target: {name, value}}) => handleChange({name, value})}
                    style={{...style}}
                />
            :
                <Controller
                    rules={{ required: required, ...rules }}
                    control={inputProps.control}
                    defaultValue={null}
                    name={identificador}
                    render={({ field: { onChange, onBlur, value } }) =>
                        (<input 
                            type="time" 
                            className="inputTime"
                            disabled={disabled}
                            name={identificador}
                            value={nestedValue ? nestedValue : isEmpty(value) ? null : value}
                            readOnly={readOnly}
                            onBlur={onBlur}
                            onChange={({target: {value}}) => onChange(value)}
                            style={{...style}}
                        />)
                    }
                />
            }
            {
            (!isEmpty(customError) || required) &&
                <span className="mt-1 pl-2 titleForm panelColorError">{customError}</span>
            }
        </FormControl>
    )
};

export default TimeForm
